export enum CardUpdateTypes {
    APPLY_CARD = 'apply_card',
    NEW_CARD = 'new_card_error'
}
